
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nextVisible = window.scrollY > 200;
      setIsVisible((previous) => (previous === nextVisible ? previous : nextVisible));
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="fixed bottom-20 right-6 z-50 rounded-full bg-background/80 backdrop-blur-md border-white/15 text-white hover:bg-accent hover:text-primary-foreground shadow-[0_10px_30px_rgba(0,0,0,0.45)]"
      aria-label="Nach oben"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <ArrowUp className="h-5 w-5" />
    </Button>
  );
}
